import {Component, OnInit, ViewChild} from '@angular/core';
import {GlobalService} from '../../../global.service';
import {EventsService} from '../../events.service';

import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-reno-cup',
  templateUrl: './reno-cup.component.html',
  styleUrls: ['./reno-cup.component.css']
})
export class RenoCupComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {
    // suppressScrollX:true
  };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;

  constructor(public eventService: EventsService, public globalService: GlobalService , private titleService:Title)
  {
    this.titleService.setTitle('Reno Cup')

  }

  ngOnInit() {
  }

}
